import { useContext } from 'react';
import { useAPICallAsync } from './useAPICallAsync';
import { API_PATH_TERMS_CONDITION, API_GATEWAY } from '../../helpers/api';
import { CentralProviderContext } from '../..';
export var useAcceptLegalTerms = function () {
    var application = useContext(CentralProviderContext).application;
    var _a = useAPICallAsync({
        api: {
            method: 'POST',
            endpoint: "".concat(API_PATH_TERMS_CONDITION, "?app_key=").concat(application),
        },
        baseRoute: API_GATEWAY,
        checkSelectedGrant: false,
    }), result = _a.result, call = _a.call;
    return {
        result: result,
        call: call,
    };
};
//# sourceMappingURL=useAcceptLegalTerms.js.map